<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar Marca' : 'Nova Marca' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            {{ isEdicao ? 'Edição' : 'Cadastro' }} de uma {{ isEdicao ? '' : 'nova' }} marca no sistema.
                        </p>
                    </div>
                </div>
            </div>

            @if(isLoading) {
            <div class="col-12">
                <app-loading-box height="200"></app-loading-box>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nome da Marca</mat-label>
                                <input matInput formControlName="nome" placeholder="Ex: Samsung, Nike, Marca Própria"
                                    required>
                                @if (form.get('nome')?.hasError('required')) {
                                <mat-error>O nome é <strong>obrigatório</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>

                </form>
            </div>
            }
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>